import { Box } from '@mui/material';
import { ListFilterSidebar } from '@/components/filters/ListFilterSidebar';

export const ContractorOwnerListFilter = () => (
    <Box
        sx={{
            color: '#fff',
            '& .MuiInputBase-input, & .MuiInputBase-input::placeholder, & .MuiTypography-root, & .MuiListItemText-primary, & .MuiButton-root, & .MuiSvgIcon-root':
                {
                    color: '#fff',
                },
            '& .MuiInputBase-input::placeholder': {
                opacity: 0.7,
            },
        }}
    >
        <ListFilterSidebar searchPlaceholder="Search name, company, etc." />
    </Box>
);
